import React, { Component } from 'react';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import { Dropdown } from 'antd';
const Picker = dynamic(() => import('./Picker'), {
  ssr: false
});

const MaterialIconButton = styled.i`
  color: #7d7878;
  border-radius: 50%;
  padding: 0px 5px;

  &:hover {
    background: #e0e0e0;
    cursor: pointer;
  }
`;

class GifButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pickerOpened: false
    };
  }

  onSelected = (gif) => {
    if (typeof this.props.onEmojiSelect === 'function') {
      const text = `[![](${gif.fixed_height.url})](${gif.original.url})`;
      this.props.onEmojiSelect(text);
    }

    this.setState({ pickerOpened: false });
  };

  onButtonClick = () => {
    this.setState({ pickerOpened: !this.state.pickerOpened });
  };

  closeDropdown = () => {
    this.setState({ pickerOpened: false });
  };

  handleVisibleChange = (flag) => {
    this.setState({ pickerOpened: flag });
  };

  render() {
    return (
      <Dropdown
        overlay={<Picker onSelected={this.onSelected} closeDropdown={this.closeDropdown} />}
        onVisibleChange={this.handleVisibleChange}
        trigger={['click']}
        visible={this.state.pickerOpened}
      >
        <MaterialIconButton className='material-icons' onClick={this.onButtonClick}>
          gif
        </MaterialIconButton>
      </Dropdown>
    );
  }
}

export default GifButton;
